import { TextareaProps } from '@chakra-ui/react'
import React, { forwardRef } from 'react'
import { ChakraFieldProps, ChakraTextAreaField } from '../ChakraField'

export type ChakraTextAreaProps = ChakraFieldProps<TextareaProps>

export const ChakraTextArea = forwardRef<HTMLTextAreaElement, ChakraTextAreaProps>((props, ref) => {
  return <ChakraTextAreaField ref={ref} {...props} />
})
